import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Transition from 'react-motion-ui-pack'
import classNames from 'classnames/bind';
import intl from 'react-intl-universal';

import { convertScreenToLeafletPt } from '../../../../../../utils/Utils';
import IconButton from '../IconButton/index';
import CancelButton from '../CancelButton/index';
import './IconDrawer.css';

@inject("appStore")
@observer
class IconDrawer extends Component {
    iconOnClick = (icon, e) => {
        let appStore = this.props.appStore;
        let elementStore = appStore.elementStore;
        if (!appStore.drawer.disabled && !icon.disabled){
            if (elementStore.store.pendingState && elementStore.store.pendingState.element){
                elementStore.createNewElement(icon, elementStore.store.pendingState.element.position, appStore.drawer.active);
            } else {
                elementStore.createNewElement(icon, convertScreenToLeafletPt([e.pageX, e.pageY], appStore.mapState.element), appStore.drawer.active);
            }
        }
    };
    cancelOnClick = (icon, e) => {
        this.props.appStore.clearPending();
    };
    expandHandler = () => {
        this.props.appStore.setDrawer({expanded:!this.props.appStore.drawer.expanded});
    };
    render() {
        const questions = this.props.appStore.appConfig.questions[this.props.appStore.drawer.active];
        return (
            <div className="IconDrawer">
                    <ul className="questionList">
                        {questions.map((question, index) =>
                            <li className="question" key={index}>
                                {index !== 0 ? <hr></hr> : '' }
                                <h4 className="text">{question.text}</h4>
                                <div>
                                    <ul className="iconList main">
                                        {question.icons.map((icon, index) => {
                                            if (this.props.appStore.pendingState.element && icon.id === this.props.appStore.pendingState.element.icon.id){
                                                return <CancelButton cancelOnClick={this.cancelOnClick.bind(this, icon)}
                                                                     type={this.props.appStore.drawer.active}
                                                                     icon={icon}
                                                                     key={index}/>
                                            } else {
                                                return <IconButton
                                                    className={classNames({'disabled': (icon.disabled && icon.id !== this.props.appStore.pendingState.element.icon.id) || (this.props.appStore.drawer.disabled)})}
                                                    iconOnClick={this.iconOnClick.bind(this, icon)}
                                                    type={this.props.appStore.drawer.active}
                                                    icon={icon}
                                                    key={index}/>
                                            }
                                        })}
                                    </ul>
                                    <Transition
                                        enter={{opacity: 1}}
                                        leave={{opacity: 0}}
                                    >
                                        {this.props.appStore.drawer.expanded &&
                                        <ul key={"iconList"} className="iconList expand">
                                            {question.icons.map((icon, index) =>
                                                <IconButton
                                                    className={classNames({'disabled': (icon.disabled && icon.id !== this.props.appStore.pendingState.element.icon.id)})}
                                                    onClick={(e, icon) => this.iconOnClick(icon, e)}
                                                    type={this.props.appStore.drawer.active}
                                                    icon={icon}
                                                    key={index}/>
                                            )}
                                        </ul>
                                        }
                                    </Transition>

                                </div>
                            </li>
                        , this)}
                    </ul>

                {questions.length > 5 &&
                    <div onClick={this.expandHandler} className="drawerToggle">
                        {intl.get("IconDrawer.expand_drawer")}
                    </div>
                }
            </div>
        );
    }
}

export default IconDrawer;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/IconDrawer/index.js